class Tabs {
    constructor(selector, options) {
        const defaultOptions = {
            activeClass: '__active',
            watchHash: false,
            triggerMap: false,
            onChange: (currentBtn, currentContainer, tabContainers) => {},
            onFirstShow: (currentBtn, currentContainer, tabContainers) => {}
        };
        this.options = Object.assign({}, defaultOptions, options);
        this.tabButtons = [...document.querySelectorAll(selector)];
        this.tabContainers = this.tabButtons.map(this.getContainerForBtn.bind(this));
        this.switchTab = this.switchTab.bind(this);
    }

    static buttonsByLinksMap = {};

    init() {
        if (this.tabButtons.length === 0) return;

        this.showCurrentTab(this.tabButtons[0], this.tabContainers[0]);
        this.addEvents();
        this.fillMap();
        this.options.watchHash && this.checkHash();
    }

    addEvents() {
        this.tabButtons.forEach((btn) => {
            btn.addEventListener('click', this.switchTab);
        });
    }

    removeEvents() {
        this.tabButtons.forEach((btn) => {
            btn.removeEventListener('click', this.switchTab);
        });
    }

    switchTab(e) {
        e.preventDefault();
        const currentBtn = e.currentTarget;

        this.options.triggerMap && this.triggerMap(currentBtn);
        if (currentBtn.classList.contains(this.options.activeClass)) return;

        const currentContainer = this.getContainerForBtn(currentBtn);
        this.showCurrentTab(currentBtn, currentContainer);

        this.options.onChange(currentBtn, currentContainer, this.tabContainers);
    };

    getBtnLink(btn) {
        if (btn.tagName === 'A') {
            return btn.getAttribute('href') || btn.getAttribute('data-fake-href');
        }
        return btn.getAttribute('rel');
    }

    getContainerForBtn(btn) {
        const link = this.getBtnLink(btn);
        const containerSelector = '[data-content-id="' + link.slice(1) + '"]';
        return document.querySelector(containerSelector) || document.querySelector(link);
    }

    isChildrenHasId(btn, id) {
        const children = [...btn.querySelectorAll('*')];
        return children.some((child) => {
            return child.id === id;
        })
    }

    showCurrentTab(currentBtn, currentContainer) {
        this.tabContainers.forEach((container) => {
            container.style.display = 'none';
        });
        this.tabButtons.forEach((btn) => {
            btn.classList.remove(this.options.activeClass);
        });

        currentContainer.style.display = '';
        currentBtn.classList.add(this.options.activeClass);
        if (!currentContainer.dataset.tabFirstShow) {
            this.options.onFirstShow(currentBtn, currentContainer, this.tabContainers);
            currentContainer.dataset.tabFirstShow = 'true';
        }
    }

    fillMap() {
        this.tabButtons.forEach((btn) => {
            const link = this.getBtnLink(btn);
            Tabs.buttonsByLinksMap[link] = Tabs.buttonsByLinksMap[link] || [];
            Tabs.buttonsByLinksMap[link].push(btn);
        });
    }

    triggerMap(targetBtn) {
        const link = this.getBtnLink(targetBtn);

        if (Tabs.buttonsByLinksMap[link]) {
            Tabs.buttonsByLinksMap[link].forEach((btn) => {
                if (btn !== targetBtn) {
                    btn.dispatchEvent(new Event('click', { cancelable: true }));
                }
            });
        }
    }

    checkHash() {
        const hash = window.location.hash;
        const targetBtn = this.tabButtons.find((btn) => {
            return this.getBtnLink(btn) === hash || this.isChildrenHasId(btn, hash.slice(1));
        }) || this.tabButtons[0];
        targetBtn.dispatchEvent(new Event('click', { cancelable: true }));
    }

    destroy() {
        this.removeEvents();
    }
}

window.initTabs = (selector, settings) => {
    const tabs = new Tabs(selector, settings);
    tabs.init();
    document.querySelector(selector).parentElement.tabs = tabs;
};
